import { gql } from '@apollo/client'

const GET_ALL_REQUEST = gql`
  query getAllMyRequests($first: Int, $offset: Int, $idWatcher: UUID) {
    requests(
      first: $first
      offset: $offset
      orderBy: START_DATE_DESC
      filter: { idWatcher: { equalTo: $idWatcher } }
    ) {
      nodes {
        id
        title
        requestAddress
        location {
          x
          y
        }
        datetimeRange {
          end {
            value
          }
          start {
            value
          }
        }
        requestTypeByIdRequestType {
          name
        }
        status
        summary
        watcherByIdWatcher {
          addressLine1
          addressLine2
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`
export default GET_ALL_REQUEST
